import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as LancamentosActions } from "../ducks/lancamentos";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";
import moment from "moment";
import { formatReal } from "../../helpers";

export function* getListLancamentos() {
  try {
    yield put(LoadingActions.setLoading());
    const { filter } = yield select(state => state.lancamentos);
    const { date_type, initial_date, finish_date } = yield select(
      state => state.filtrosLancamentos
    );
    if (!filter.search) {
      filter.date_type =
        date_type.split("-", 1)[0] === "1"
          ? "due_date"
          : date_type.split("-", 1)[0] === "2"
          ? "paid_at"
          : date_type.split("-", 1)[0] === "3"
          ? "invoice_date"
          : null;
      filter.initial_date = moment(initial_date).format("DD/MM/YYYY");
      filter.finish_date = moment(finish_date).format("DD/MM/YYYY");
    }
    const data = yield call(api.post, `/financial/invoices/filter`, filter);
    const total = data.data.data.length;

    let lancamentosPayload = [];
    lancamentosPayload = data.data.data.map((lancamentos, index) => ({
      ...lancamentos,
      uid: `${index}-${lancamentos.date}-${lancamentos.order}-${lancamentos.type}`,
      date: lancamentos.due_date
        ? moment(lancamentos.due_date).format("DD/MM/YYYY")
        : "",
      invoice_date: lancamentos.invoice_date
        ? moment(lancamentos.invoice_date).format("DD/MM/YYYY")
        : "",
      paid_at: lancamentos.paid_at
        ? moment(lancamentos.paid_at).format("DD/MM/YYYY")
        : "",
      parcelas: `${lancamentos.installment_number}/${
        lancamentos.installments ? lancamentos.installments : 1
      }`,
      balance:
        lancamentos.balance >= 0
          ? `<span class="flex-end">${formatReal(lancamentos.balance)}</span>`
          : `<span class="flex-end">${formatReal(lancamentos.balance)}</span>`,
      valor:
        lancamentos.type === "1" || lancamentos.type === 1
          ? `<span class="${lancamentos.value_paid !== null &&
              "red-alert font-weight-normal"} flex-end">-${formatReal(
              lancamentos.installment_value
            )}</span>`
          : ` <span class="${lancamentos.value_paid !== null &&
              "green-alert font-weight-normal"} flex-end">${formatReal(
              lancamentos.installment_value
            )}</span>`,
      pure_valor:
        lancamentos.type === "1" || lancamentos.type === 1
          ? -lancamentos.installment_value
          : lancamentos.installment_value,
      atrasado:
        moment(lancamentos.due_date) < moment(moment().format("YYYY-MM-DD")) &&
        lancamentos.value_paid === null,
      category: lancamentos.items
        .map(
          item =>
            `<span class="category-label">${item.category}` +
            (item.description
              ? `<span class="tag-hover" style="font-size: 1.2rem !important">${item.description}</span>`
              : "") +
            `</span>`
        )
        .join(""),
      usuario: lancamentos.user ? lancamentos.user.name : "",
      loja: lancamentos.store
        ? lancamentos.store.name
        : lancamentos.partitioned
        ? "has_rateio"
        : "",
      idInvoice: lancamentos.invoice_id,
      transactions: lancamentos.transactions,
      pago: !!lancamentos.value_paid
        ? '<i class="fa fa-check-square fs2"></i>'
        : "",
      rateio: lancamentos.partitioned ? '<i class="fa fa-sitemap fs2"></i>' : ""
    }));
    const name = "Lançamentos";
    const path = "lancamentos";
    yield put(PageActions.setPage(name, path));
    yield put(
      LancamentosActions.getListLancamentosSuccess(
        lancamentosPayload,
        total,
        data.data.totals
      )
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getExport() {
  try {
    yield put(LoadingActions.setLoading());
    const { filter } = yield select(state => state.lancamentos);
    const { date_type, initial_date, finish_date } = yield select(
      state => state.filtrosLancamentos
    );
    if (!filter.search) {
      filter.date_type =
        date_type.split("-", 1)[0] === "1"
          ? "due_date"
          : date_type.split("-", 1)[0] === "2"
          ? "paid_at"
          : date_type.split("-", 1)[0] === "3"
          ? "invoice_date"
          : null;
      filter.initial_date = moment(initial_date).format("DD/MM/YYYY");
      filter.finish_date = moment(finish_date).format("DD/MM/YYYY");
    }
    filter.export = true;
    const data = yield call(api.post, `/financial/invoices/filter`, filter);
    window.open(data.data, "_blank");
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getLancamentos({ payload }) {
  try {
    const { action } = yield select(state => state.lancamentosStores);
    if (action !== "DETAILS INVOICE" && action !== "EDIT INVOICE") {
      yield put(LoadingActions.setLoading());
      const { data } = yield call(
        api.get,
        `/financial/invoices/installments/${payload.id}`
      );
      yield put(LancamentosActions.getLancamentosSuccess(data));
    } else {
      yield put(LoadingActions.setLoading());
      const { data } = yield call(api.get, `/financial/invoices/${payload.id}`);
      yield put(LancamentosActions.getLancamentosSuccess(data));
    }
    if (
      action === "EDIT" ||
      action === "DETAIL" ||
      action === "DETAILS INVOICE" ||
      action === "EDIT INVOICE"
    ) {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O(s) cadastro(s) serão excluídos do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editLancamentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { action } = yield select(state => state.lancamentosStores);
    if (action !== "EDIT INVOICE") {
      yield call(
        api.put,
        `/financial/invoices/installments/${payload.id}`,
        payload
      );
    } else {
      yield call(api.put, `/financial/invoices/${payload.id}`, payload);
    }
    yield put(LancamentosActions.getListLancamentos());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addLancamentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/financial/invoices`, payload);
    yield put(LancamentosActions.searchLancamentos({}));
    yield put(LancamentosActions.getListLancamentos());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteLancamentos() {
  try {
    yield put(LoadingActions.setLoading());
    const { invoice_id } = yield select(state => state.lancamentos.item);
    yield call(api.delete, `/financial/invoices/${invoice_id}`);
    yield put(LancamentosActions.getListLancamentos());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* deleteLancamentosParcela() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.lancamentos.item);
    yield call(api.delete, `/financial/invoices/installments/${id}`);
    yield put(LancamentosActions.getListLancamentos());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchLancamentos() {
  try {
    yield put(LancamentosActions.getListLancamentos());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListLancamentosSelects() {
  try {
    const { data: lancamentos } = yield call(
      api.get,
      `/financial/invoices/select`
    );
    yield put(LancamentosActions.getListLancamentosSuccessSelects(lancamentos));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllLancamentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/financial/invoices/destroy-many`, {
      ids: payload.selected,
      target: payload.target
    });
    yield put(LancamentosActions.getListLancamentos());
    if (payload.selected.length > 1 && payload.target !== "fatura") {
      yield put(
        SuccessActions.openSuccess("Lançamentos excluídos com sucesso.")
      );
    } else if (payload.target !== "fatura") {
      yield put(
        SuccessActions.openSuccess("O lançamento foi excluído com sucesso.")
      );
    } else {
      yield put(
        SuccessActions.openSuccess("A fatura foi excluída com sucesso.")
      );
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/lancamentos.js